import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { installCrashReporter } from './lib/crash';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Prices arrive over the socket, so refetching a list because the tab
      // regained focus buys nothing and costs a request storm on return.
      refetchOnWindowFocus: false,
      staleTime: 10_000,
      retry: 1,
    },
  },
});

// Fatal errors post to the API's crash intake so a white screen in
// production is visible to us, not only to the person it happened to.
installCrashReporter();

const root = document.getElementById('root');
if (!root) throw new Error('#root missing from index.html');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
